// extracted by mini-css-extract-plugin
export default {"image":"style_image__OjyA+","primaryImg":"style_primaryImg__cgspL","options":"style_options__O1lOA","editorChoice":"style_editorChoice__fkQeZ"};